import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-行政",
  "use": "vab-icon-行政-usage",
  "viewBox": "0 0 1128 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1128 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"vab-icon-行政\"><path d=\"M330.856 15.716h248.142v992.568H330.856z m314.975 44.5L886.53 0l240.864 962.957-240.698 60.133zM0 15.716h248.142v992.568H0z\" p-id=\"6269\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol